// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__QD4eF","active":"Statics_active__d5iRZ"};